module.exports = "<div class=\"inp-text prop\" :class=\"{'focus-prop':focus&&!focusFrom,'focus-from':focusFrom}\" @click.stop> <label class=inp-label :for=_uid :title=prop>{{niceProp}}</label> <component :is=renderType :fragment.sync=parent[prop] :id=_uid></component> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prop.vue
 ** module id = 140
 ** module chunks = 0
 **/